import { z } from 'zod/v4';

import { hazmatTypeSchema } from './hazmat-type.schema';
import { tunnelCategorySchema } from './tunnel-category.schema';
import { vehicleConfigurationSchema } from './vehicle-configuration.schema';

export const vehicleOptionsSchema = z.object({
  vehicleConfig: vehicleConfigurationSchema.optional(),
  governorSpeedLimit: z.number().optional(),
  hazmatType: hazmatTypeSchema.optional(),
  tunnelCategory: tunnelCategorySchema.optional(),
});

export type VehicleOptions = z.infer<typeof vehicleOptionsSchema>;
